import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import type { UserInfo } from "@/types/user/userInfo";
import { defaultUserInfo } from "@/types/user/userInfo";

export type AuthStatus = "idle" | "loading" | "succeeded" | "failed";

export interface AuthState {
  user: UserInfo;
  status: AuthStatus;
  loggedIn: boolean;
  error: string | null;
  isEmployee: boolean;
  accessToken: string | null;
  refreshToken: string | null;
}

const initialState: AuthState = {
  user: defaultUserInfo,
  status: "idle",
  loggedIn: false,
  error: null,
  isEmployee: false,
  accessToken: null,
  refreshToken: null,
};

const useAuth = create<AuthState>()(
  devtools(
    persist(() => initialState, {
      name: "auth-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        loggedIn: state.loggedIn,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
      }),
    }),
    { name: "auth-state" },
  ),
);

export default useAuth;
